import React from 'react';
import styled from 'styled-components';
import Button from 'components/Navigation/Components/Button';
import {X, Trash2, Minus, Plus} from 'react-feather';
import PropTypes from 'prop-types';
import {path, pathOr, prop} from 'ramda';
import noPhoto from 'media/no-photo.jpeg';
import useCard from 'hooks/useCard';
import formatNumber from 'helpers/formatNumber';
import {bottomSheet} from 'react-simple-bottom-sheet';
import SetAmount from 'components/SetAmount';
import {useTranslate} from 'helpers/translate';
import Detail from 'components/Detail';
import numberFormat from "../../helpers/numberFormat";
import toNumber from "../../helpers/toNumber";

const Wrapper = styled('div')`
  height: 90px;
  margin-top: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: relative;
  border-radius: 10px;
  width: ${({width}) => width || '100%'};
  background: #FFFFFF;
  cursor: pointer;
`

const Content = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
`

const FullWidth = styled.div`
  width: 100%;
`

const Image = styled('div')`
  width: 20%;
  height: 100%;
  position: absolute; 
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0.5px solid rgb(242, 242, 242);
  border-radius: 6px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Price = styled('div')`
  display: flex;
  margin-top: 6px;
  align-items: center;

  & * {
    font-family: var(--medium);
  }
  & > :not(:last-child) {
    margin-right: 4px;
  }
  & p {
    display: flex;
    align-items: center;
    font-size: 15px;
    line-height: 14px;
    text-align: right;
    color: #252325;
  }
`

const Right = styled('div')`
  width: 100%;
  height: 100%;
  padding: 10px 10px 10px 23%; 
`

const Name = styled('div')`
  width: 90%;
  margin-bottom: 10px;

  & * {
    font-family: var(--light);
  }

  & p {
    font-size: 14px;
    color: #252325;
    mix-blend-mode: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const Header = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: -10px;

  .flex {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  & p {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    letter-spacing: -0.5px;
    color: ${({link}) => link ? '#2934D0' : '#282828'};

  }
`

const Bottom = styled('span')`
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 5px;
  right: 5px;
`

const Amount = styled('div')`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 5px;
  background: #F2F2F2;
  border-radius: 8px;
  overflow: hidden;
`

const Available = styled('div')`
  display: flex;
  margin-top: 6px;
  align-items: center;

  & * {
      font-family: var(--medium);
  }

  & p {
      font-size: 14px;
      line-height: 14px;
      text-align: right;
      color: #475061;
  }
`

const Label = styled('div')`
    width: 50px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;

    & input {
        max-width: 60px;
        border: none;
        outline: none;
        height: 45px;
        text-align: center;
    }

    & p {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 135%;
        text-align: center;
        color: #000000;
    }
`

const ListCard = (props) => {
  const {key, data, onDelete, isOrder, withAvailable, customCurrency} = props

  const {exist, amount, handleRemove, handleChange, handleAdd} = useCard(data)

  const {t} = useTranslate()
  // Data
  const image = path(['image', 'file'], data)
  const name = path(['name'], data)
  const cashPrice = path(['cashPrice'], data)
  const available = path(['available'], data)
  const boxAmount = path(['boxAmount'], data)
  const boxName = path(['boxName'], data)
  const currency = pathOr(customCurrency, ['currency', 'name'], data);
  const measurement = path(['measurement', 'name'], data);

  const boxValue = Math.floor(amount / boxAmount);
  const amountValue = amount % boxAmount;

  const openDetail = () => {
    document.querySelector('body').classList.add('hidden')
    bottomSheet.close({id: 'set-amount'})
    bottomSheet.create({
      content: <Detail
        isOrder={isOrder}
        withAvailable={withAvailable}
        data={data}
      />,
      id: 'detail',
      dragHandle: ['mask'],
      header: detailHeaderContent
    })
  }

  const detailHeaderContent = (
    <Header>
      <div className={'flex'}>
        <p style={{width: '90%'}}>{name}</p>
        <X size={20} onClick={() => {
          bottomSheet.close({id: 'detail'})
          document.querySelector('body').classList.remove('hidden')
        }}/>
      </div>
      {boxAmount ? (
        <FullWidth style={{marginTop: '10px'}}>
          <FullWidth className={'flex'}>
            <SetAmount
              isOrder={isOrder}
              amount={amountValue}
              label={measurement}
            />
            <SetAmount
              isOrder={isOrder}
              name={'productBox'}
              amount={boxValue}
              label={`${boxName} (${numberFormat(boxAmount, measurement, ' ')})`}
            />
          </FullWidth>
          <FullWidth className={'flex'} style={{marginTop: '10px'}}>
            <Button
              width={'50%'}
              height={'50px'}
              style={{
                fontSize: '16px !important',
                fontWeight: '500',
                fontFamily: '"Medium", sans-serif !important'
              }}
              radius={'10px'}
              background={'#e66767'}
              onClick={() => {
                onDelete && onDelete()
                handleRemove(amount * -1)
                bottomSheet.close({id: 'detail'})
                document.querySelector('body').classList.remove('hidden')
              }}
              title={t('delete_cart')}
            />
            <Button
              width={'50%'}
              height={'50px'}
              style={{
                fontSize: '16px !important',
                fontWeight: '500',
                fontFamily: '"Medium", sans-serif !important'
              }}
              radius={'10px'}
              onClick={() => {
                const rawBox = window.productBox
                const rawAmount = window.productAmount

                const finalBox = typeof rawBox === 'number' ? rawBox : boxValue
                const finalAmount = typeof rawAmount === 'number' ? rawAmount : amountValue

                const final = toNumber(finalAmount) + toNumber(finalBox * boxAmount)

                handleChange(final)
                bottomSheet.close({ id: 'detail' })
                document.querySelector('body').classList.remove('hidden')
              }}
              title={t('add_to_cart')}
            />
          </FullWidth>
        </FullWidth>
      ) : (
        <div className={'flex'} style={{marginTop: '10px'}}>
          <SetAmount
            isOrder={isOrder}
            isDetail
            amount={amount === null || amount === 0 ? null : amount}
            width={'50%'}
          />
          <Button
            width={'50%'}
            height={'50px'}
            style={{
              fontSize: '16px !important',
              fontWeight: '500',
              fontFamily: '"Medium", sans-serif !important'
            }}
            radius={'10px'}
            onClick={() => {
              handleChange(window.productAmount === 0 ? 0 : window.productAmount || amount)
              bottomSheet.close({id: 'detail'})
              document.querySelector('body').classList.remove('hidden')
            }}
            title={t('add_to_cart')}
          />
        </div>
      )}
    </Header>
  );

  return (
    <Wrapper key={key} onClick={openDetail}>
      <Content>
        <Image>
          <img src={image || noPhoto} alt={''}/>
        </Image>
        <Right>
          <Name>
            <p>
              {name}
            </p>
          </Name>
          <Price>
            <p>{formatNumber(cashPrice, `${currency}`, ' ')}</p>
            {
              isOrder ?
                <>
                  <p><X size={12}/></p>
                  <p>{formatNumber(prop('amount', data))}</p>
                  <p>=</p>
                  <p>{formatNumber(prop('totalPrice', data), currency, ' ')}</p>
                </>
                : null
            }
          </Price>
          {available && <Available>
            <p>{formatNumber(available, measurement)}</p>
          </Available>}
          <Bottom onClick={(e) => e.stopPropagation()}>
            <>
              {
                !isOrder ?
                  <>
                    {!exist ?
                      (
                        <Button
                          onClick={() => handleChange(amount || 1)}
                          style={{
                            fontSize: '14px !important',
                            fontWeight: '400',
                            fontFamily: '"Medium", sans-serif !important'
                          }}
                          title={t('add_to_cart')}
                          width={'120px'}
                          height={'35px'}
                          radius={'8px'}
                        />
                      )
                      : (
                        <Amount>
                          <Button
                            onClick={() => handleRemove()}
                            title={amount === 1 ? <Trash2 stroke={'#F43F3C'} size={15}/> : <Minus stroke={'#2934D0'} size={15}/>}
                            width={'30px'}
                            height={'35px'}
                            background={'transparent'}
                          />
                          <Label onClick={openDetail}>
                            <p>{formatNumber(amount, measurement, ' ')}</p>
                          </Label>
                          <Button
                            onClick={() => handleAdd()}
                            title={<Plus stroke={'#2934D0'} size={15}/>}
                            width={'30px'}
                            height={'35px'}
                            background={'transparent'}
                          />
                        </Amount>
                      )
                    }
                  </>
                  : null
              }
            </>
          </Bottom>
        </Right>
      </Content>
    </Wrapper>
  );
};

ListCard.propTypes = {
  key: PropTypes.any
}

export default ListCard;
